import { ProjectDetailsDto } from 'types/projects.ts';
import MattersTableWithFilters from '../../matters/MattersTableWithFilters.tsx';

type Props = {
    project: ProjectDetailsDto;
};

const CasesView = ({ project }: Props) => {
    const matterIds = project.matters?.map((m) => m.id) ?? [];
    const joinedMatterIds = matterIds.length > 0 ? matterIds.join(',') : '0';
    return (
        <div className="flex h-full flex-col gap-4">
            <MattersTableWithFilters passiveFilter={`id=in=(${joinedMatterIds})`} disableExport />
        </div>
    );
};

export default CasesView;
